import { render, staticRenderFns } from "./orderConfirmModal.vue?vue&type=template&id=ef1b21f6&scoped=true"
import script from "./orderConfirmModal.vue?vue&type=script&lang=js"
export * from "./orderConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./orderConfirmModal.vue?vue&type=style&index=0&id=ef1b21f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1b21f6",
  null
  
)

export default component.exports